import { createFileRoute } from '@tanstack/react-router';

import { Dashboard } from '~/modules/dashboard';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { routeParams } from './-routeParams';

export const Route = createFileRoute('/(main)/analytics/')({
  beforeLoad: createProtectedRoute({
    routePath: '/analytics',
    ...routeParams,
  }),
  component: Dashboard,
});

export const ANALYTICS = buildRouteExport({ Route, ...routeParams });
